import { APIEndpoints, APIPaths } from "../../Services/AWS/APIEndpoints";
import { fetchAuthenticatedUser } from "../../Services/Redux/actionCreators/userActions/loginActions";
import { getAPI, initializeAPIOptions, postAPI } from "../../Utils/API";
import { configuration } from "./data/configuration";
import { mockDaemonInfo } from "./mocks/mockDaemonInfo";

// HaaS v1
/**
 * @deprecated Haas v1
 */
const startDaemon = (daemonId) => async (dispatch) => {
    const { token } = await dispatch(fetchAuthenticatedUser());
    const apiName = APIEndpoints.DEPLOYER.name;
    const apiPath = APIPaths.START_DAEMON(daemonId);
    const apiOptions = initializeAPIOptions(token);
    return await getAPI(apiName, apiPath, apiOptions);
};

// HaaS v2
/* billing */
const getBalance = () => async (dispatch) => {
    const { token } = await dispatch(fetchAuthenticatedUser());
    const apiName = APIEndpoints.DEPLOYER.name;
    const apiPath = APIPaths.GET_BALANCE;
    const apiOptions = initializeAPIOptions(token);
    return await getAPI(apiName, apiPath, apiOptions);
};
const initiateOrder =
    ({ amount }) =>
    async (dispatch) => {
        const { token } = await dispatch(fetchAuthenticatedUser());
        const apiName = APIEndpoints.DEPLOYER.name;
        const apiPath = APIPaths.INITIATE_ORDER;
        const apiOptions = initializeAPIOptions(token, {
            amount,
        });

        return await postAPI(apiName, apiPath, apiOptions);
    };
const saveTransaction =
    ({ orderId, transactionHash, sender, recipient }) =>
    async (dispatch) => {
        const { token } = await dispatch(fetchAuthenticatedUser());
        const apiName = APIEndpoints.DEPLOYER.name;
        const apiPath = APIPaths.SAVE_EVM_TRANSACTION;
        const apiOptions = initializeAPIOptions(token, {
            orderId,
            transactionHash,
            sender,
            recipient,
        });
        return await postAPI(apiName, apiPath, apiOptions);
    };

/**
 * @param {Object} param0
 * @param {number} param0.limit //for pagination
 * @param {number} param0.page //for pagination
 * @param {"asc" | "desc"} param0.order //sorter
 * @param {"hour" | "day" | "week" | "month" | "year" | "all"} param0.period //filter
 * @param {"income" | "expense" | "all"} param0.type //filter
 * @param {"success" | "failed" | "pending" | "all"} param0.status //filter
 * @returns
 */
const getBalanceHistory =
    ({ limit, page, order, period, type, status }) =>
    async (dispatch) => {
        const { token } = await dispatch(fetchAuthenticatedUser());
        const apiName = APIEndpoints.DEPLOYER.name;

        const apiPath = APIPaths.GET_BALANCE_HISTORY;
        const params = {
            limit,
            page,
            order,
            period,
            type,
            status,
        };

        const apiOptions = initializeAPIOptions(token, undefined, params);
        return await getAPI(apiName, apiPath, apiOptions);
    };
/* /billing */

/* deployments */
const getPublicKey = () => async (dispatch) => {
    const { token } = await dispatch(fetchAuthenticatedUser());
    const apiName = APIEndpoints.DEPLOYER.name;
    const apiPath = APIPaths.GET_PUBLIC_KEY;
    const apiOptions = initializeAPIOptions(token);
    return await getAPI(apiName, apiPath, apiOptions);
};

/**
 * @param {Object} param0
 * @param {number} param0.limit //for pagination
 * @param {number} param0.page //for pagination
 * @param {"asc" | "desc"} param0.order //sorter
 * @param {"created_at"} param0.orderBy //sorter
 * @returns
 */
const getUserDeployments =
    ({ limit, page = 1, order = "asc", orderBy = "created_at" }) =>
    async (dispatch) => {
        const { token } = await dispatch(fetchAuthenticatedUser());
        const apiName = APIEndpoints.DEPLOYER.name;

        const apiPath = APIPaths.GET_USER_DEPLOYMENTS;
        const params = {
            limit,
            page,
            order,
            orderBy,
        };

        const apiOptions = initializeAPIOptions(token, undefined, params);
        return await getAPI(apiName, apiPath, apiOptions);
    };
const searchDeployments = (orgUuid, serviceUuid) => async (dispatch) => {
    const { token } = await dispatch(fetchAuthenticatedUser());
    const apiName = APIEndpoints.DEPLOYER.name;
    const apiPath = APIPaths.SEARCH_DEPLOYMENTS;
    const params = {
        orgId: orgUuid,
        serviceId: serviceUuid,
    };
    const apiOptions = initializeAPIOptions(token, undefined, params);
    return await getAPI(apiName, apiPath, apiOptions);
};
/**
 * @param {Object} param0
 * @param {string} param0.orgId
 * @param {string} param0.serviceId
 * @param {boolean} param0.onlyDaemon
 * @param {string | undefined} param0.serviceEndpoint //only for Daemon tab
 * @param {Array<{key: string, value: string, location: string}> | undefined} param0.serviceCredentials //only for Daemon tab
 * @param {string | undefined} param0.githubAccountName //only for DaemonAI tab
 * @param {string | undefined} param0.githubRepositoryName //only for DaemonAI tab
 */
const initiateDeployment =
    ({
        orgId,
        serviceId,
        onlyDaemon,
        serviceEndpoint,
        serviceCredentials,
        githubAccountName,
        githubRepositoryName,
    }) =>
    async (dispatch) => {
        const { token } = await dispatch(fetchAuthenticatedUser());
        const apiName = APIEndpoints.DEPLOYER.name;
        const apiPath = APIPaths.INITIATE_DEPLOYMENT;
        const params = {
            orgId,
            serviceId,
            onlyDaemon,
            serviceEndpoint,
            serviceCredentials,
            githubAccountName,
            githubRepositoryName,
        };
        const apiOptions = initializeAPIOptions(token, params);
        return await postAPI(apiName, apiPath, apiOptions);
    };
/* /deployments */

/* daemon */
const getDaemonInfo = (daemonId) => async (dispatch) => {
    if (configuration.debug.enable && configuration.debug.useMockDaemonInfo) {
        return mockDaemonInfo;
    }

    const { token } = await dispatch(fetchAuthenticatedUser());
    const apiName = APIEndpoints.DEPLOYER.name;
    const apiPath = APIPaths.GET_DAEMON(daemonId);
    const apiOptions = initializeAPIOptions(token);
    return await getAPI(apiName, apiPath, apiOptions);
};
const getDaemonLogs = (daemonId) => async (dispatch) => {
    const { token } = await dispatch(fetchAuthenticatedUser());
    const apiName = APIEndpoints.DEPLOYER.name;
    const apiPath = APIPaths.GET_DAEMON_LOGS(daemonId);
    const apiOptions = initializeAPIOptions(token);
    return await getAPI(apiName, apiPath, apiOptions);
};
const downloadDaemonLogs = (daemonId) => async (dispatch) => {
    const { token } = await dispatch(fetchAuthenticatedUser());
    const apiName = APIEndpoints.DEPLOYER.name;
    const apiPath = APIPaths.DOWNLOAD_DAEMON_LOGS(daemonId);
    const apiOptions = initializeAPIOptions(token);
    return await getAPI(apiName, apiPath, apiOptions, undefined, { raw: true });
};
const saveDaemonConfig = (daemonId, serviceEndpoint, serviceCredentials) => async (dispatch) => {
    const { token } = await dispatch(fetchAuthenticatedUser());
    const apiName = APIEndpoints.DEPLOYER.name;
    const apiPath = APIPaths.UPDATE_DAEMON_CONFIG(daemonId);
    const apiOptions = initializeAPIOptions(token, {
        serviceEndpoint: serviceEndpoint ?? null,
        serviceCredentials: serviceCredentials ?? null,
    });
    return await postAPI(apiName, apiPath, apiOptions);
};
/* /daemon */

/* hosted service */
const getServiceInfo = (serviceId) => async (dispatch) => {
    const { token } = await dispatch(fetchAuthenticatedUser());
    const apiName = APIEndpoints.DEPLOYER.name;
    const apiPath = APIPaths.GET_SERVICE(serviceId);
    const apiOptions = initializeAPIOptions(token);
    return await getAPI(apiName, apiPath, apiOptions);
};
const getServiceLogs = (serviceId) => async (dispatch) => {
    const { token } = await dispatch(fetchAuthenticatedUser());
    const apiName = APIEndpoints.DEPLOYER.name;
    const apiPath = APIPaths.GET_SERVICE_LOGS(serviceId);
    const apiOptions = initializeAPIOptions(token);
    return await getAPI(apiName, apiPath, apiOptions);
};
const downloadServiceLogs = (serviceId) => async (dispatch) => {
    const { token } = await dispatch(fetchAuthenticatedUser());
    const apiName = APIEndpoints.DEPLOYER.name;
    const apiPath = APIPaths.DOWNLOAD_SERVICE_LOGS(serviceId);
    const apiOptions = initializeAPIOptions(token);
    return await getAPI(apiName, apiPath, apiOptions, undefined, { raw: true });
};

/**
 * @param {Object} param0
 * @param {("hour" | "day" | "week" | "month" | "year" | "all")} param0.period
 * @returns
 */
const getMetrics =
    ({ serviceId, period }) =>
    async (dispatch) => {
        const { token } = await dispatch(fetchAuthenticatedUser());
        const apiName = APIEndpoints.DEPLOYER.name;
        const apiPath = APIPaths.GET_METRICS(serviceId);
        const apiOptions = initializeAPIOptions(token, undefined, {
            period,
        });
        return await getAPI(apiName, apiPath, apiOptions);
    };

/**
 * @param {Object} param0
 * @param {("hour" | "day" | "week" | "month" | "year" | "all")} param0.period
 * @returns
 */
const downloadMetrics =
    ({ serviceId, period }) =>
    async (dispatch) => {
        const { token } = await dispatch(fetchAuthenticatedUser());
        const apiName = APIEndpoints.DEPLOYER.name;
        const apiPath = APIPaths.DOWNLOAD_METRICS(serviceId);
        const apiOptions = initializeAPIOptions(token, undefined, {
            period,
        });
        return await getAPI(apiName, apiPath, apiOptions, undefined, { raw: true });
    };
/**
 * @param {Object} payload
 * @param {string} payload.accountName
 * @param {string} payload.repositoryName
 */
const checkGitRepository = (payload) => async (dispatch) => {
    const { token } = await dispatch(fetchAuthenticatedUser());
    const apiName = APIEndpoints.DEPLOYER.name;
    const apiPath = APIPaths.CHECK_GIT_REPOSITORY;
    const apiOptions = initializeAPIOptions(token, undefined, payload);
    return await getAPI(apiName, apiPath, apiOptions);
};
/* /hosted service */

export {
    // HaaS v1
    startDaemon,

    // HaaS v2
    /* billing */
    getBalance,
    initiateOrder,
    saveTransaction,
    getBalanceHistory,
    /* /billing */

    /* deployments */
    getPublicKey,
    getUserDeployments,
    searchDeployments,
    initiateDeployment,
    /* /deployments */

    /* daemon */
    getDaemonInfo,
    getDaemonLogs,
    downloadDaemonLogs,
    saveDaemonConfig,
    /* /daemon */

    /* hosted service */
    getServiceInfo,
    getServiceLogs,
    downloadServiceLogs,
    getMetrics,
    downloadMetrics,
    checkGitRepository,
    /* /hosted service */
};
